import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: "1 1 auto",
      flexDirection: "column",
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(4, 6),
      height: "100%",
    },
    settingsContainer: {
      flex: "1 1 100%",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
    },
  })
);
